import React from "react";
import TableColumn from '../atoms/TableColumn';

const TableRow = ({ setting }) => {
  return (
    <tr className="data-row">
      <TableColumn name={setting.name} value={setting.value} />
    </tr>
  );
};

export default TableRow;